<script setup lang="ts">
import type { Content } from '@prismicio/client'

defineProps(getSliceComponentProps<Content.HeroSlice>());

const heroEl = ref<HTMLElement | null>(null)
const parallax = ref(0)
let raf = 0

function onScroll() {
  if (!heroEl.value) return
  if (typeof window !== 'undefined' && !window.matchMedia('(min-width: 768px)').matches) {
    parallax.value = 0
    return
  }
  cancelAnimationFrame(raf)
  raf = requestAnimationFrame(() => {
    const rect = heroEl.value!.getBoundingClientRect()
    const scrolled = Math.max(0, Math.min(-rect.top, rect.height))
    parallax.value = scrolled * 0.25
  })
}

onMounted(() => {
  window.addEventListener('scroll', onScroll, { passive: true })
  onScroll()
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', onScroll)
  cancelAnimationFrame(raf)
})
</script>

<template>
  <section ref="heroEl" class="pa-hero">
    <figure class="pa-hero__image">
      <PrismicImage
        v-if="slice.primary.backgroundImage.url"
        :field="slice.primary.backgroundImage"
        class="pa-hero__image-img"
        :style="{ transform: `translate3d(0, ${parallax}px, 0)` }"
      />
    </figure>
    <div class="pa-hero__content">
      <div class="pa-hero__content-inner">
        <h1 class="pa-hero__content-title">{{ slice.primary.title }}</h1>
        <PrismicRichText :field="slice.primary.description" />
        <TrackedPrismicLink
          v-if="slice.primary.buttonLink && ('id' in slice.primary.buttonLink || 'url' in slice.primary.buttonLink)"
          :field="slice.primary.buttonLink"
          :track="slice.primary.buttonTrackEvent"
          class="pa-btn pa-btn--white"
        >
          {{ slice.primary.buttonText || "Meer info" }}
        </TrackedPrismicLink>
      </div>
    </div>
  </section>
</template>
